"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var runAuction_1 = __importDefault(require("../helpers/runAuction"));
/**
 * clear the original ad and run an auction again to get a new ad to show in the div
 *
 * returns the new ad unit id
 */
var refreshAd = function (adConfiguration) {
    return function () {
        var placement = adConfiguration.placement, context = adConfiguration.context, testGroups = adConfiguration.testGroups, deviceType = adConfiguration.deviceType, userGeo = adConfiguration.userGeo;
        var element = document.getElementById(placement);
        if (!element) {
            console.warn("refresh failed: element with id ".concat(placement, " does not exist"));
            return;
        }
        element.innerHTML = "";
        (0, runAuction_1.default)(placement, testGroups, context, userGeo, deviceType);
    };
};
exports.default = refreshAd;
